import CheckoutOverlay from '../../CheckoutOverlay';
import FrasersPlusOverlayLazyLoader from './FrasersPlusOverlayLazyLoader';

export default function FrasersPlusOverlay() {
  return (
    <CheckoutOverlay
      id="FrasersPlusOverlay"
      popup
      nopadding
      fullscreenMobile
    >
      <FrasersPlusOverlayLazyLoader />
    </CheckoutOverlay>
  );
}
